module.exports = __webpack_public_path__ + "static/img/Leonid-Mukhamedov2017-18.412a6ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Leonid-Mukhamedov2017-18.jpg
// module id = gWSb
// module chunks = 0